module.exports = __webpack_public_path__ + "images/cb5346add9a13c58b4ef627d47467d22.svg";